export default {"src":"/_next/static/media/cart-gradient.5c40837e.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};